import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Popover from 'researcher/components/Popover';
import { useTranslate } from 'shared/helper/translate';
var FapiaoStatusHint = function FapiaoStatusHint(_ref) {
  var hintTerm = _ref.hintTerm,
    _ref$alternateHintTer = _ref.alternateHintTerm,
    alternateHintTerm = _ref$alternateHintTer === void 0 ? '' : _ref$alternateHintTer;
  var _useTranslate = useTranslate(),
    translationExists = _useTranslate.translationExists;
  var hintTermTranslationExists = translationExists(hintTerm);
  var alternateHintTermTranslationExists = translationExists(alternateHintTerm);
  if (!hintTermTranslationExists && !alternateHintTermTranslationExists) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Popover, {
    content: hintTermTranslationExists ? hintTerm : alternateHintTerm
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2 text-muted",
    icon: "fa-solid fa-circle-info"
  }));
};
export default FapiaoStatusHint;